export function getTimestamp() {
  return String(Date.now());
}